import script from "./AnswerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerPanel.vue?vue&type=script&setup=true&lang=js"

import "./AnswerPanel.vue?vue&type=style&index=0&id=cb2aaf20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb2aaf20"]])

export default __exports__